import { useQuery } from 'react-query';
import { getEmployeeLeaveRequests } from 'RestAPIs/employees/leave-requests';

const useGetEmployeeLeaveRequests = (employeeId: number) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['employeeLeaveRequests', 'list', employeeId],
    async () => {
      const { data } = await getEmployeeLeaveRequests(employeeId);
      return data;
    }
  );
  return { data, isFetching, isError, refetch };
};

export default useGetEmployeeLeaveRequests;
